import React from 'react';
import './BusinessLoan.css';
import 'animate.css/animate.min.css';
import Seo from "../components/Seo";





function BusinessLoan() {
  return (
    <>

    <Seo
        title="Best Business Loan Offers & Interest Rates 2025 - Mortbuzz"
        description="Get the best business loan offers in 2025 with low interest rates, flexible repayment, and quick approval. Compare top banks and NBFCs with Mortbuzz."
        keywords="business loan 2025, best business loan offers, business loan interest rates, small business loan, MSME loan, startup loan"
        canonical="https://www.mortbuzz.in/business-loan"
      />



    {/* Hero Section */}
      <section className="mortbuzzhheroBusiness position-relative d-flex flex-column justify-content-center">
        <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
        <div className="container">
          <h1 className="animate__animated animate__fadeInDown">Fuel Your Business Growth with MortBuzz business loan in pune</h1>
          <p className="lead animate__animated animate__fadeInUp animate__delay-1s">Find the best business loan in pune solutions tailored for you.</p>
          <a href="apply-now" className="apply-btn-glass mt-4 animate__animated animate__fadeInUp animate__delay-2s">Apply Now</a>
        </div>
      </section>



{/*!-- About Home Loan -->*/}
<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
                <img src="/images/FrontPage/bussineloanimage.png" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
            <div className="col-lg-6 text-white">
                <h2 className="mb-4 text-white ">Why Choose MortBuzz business loan in pune</h2>
                <p>Home ownership is within your reach! Whether you wish to buy, construct, renovate, or expand — we make it easy and affordable with unmatched low interest rate business loan in pune market insights and end-to-end support. apply for business loan online</p>
                <ul className="list-unstyled mt-3">
                    <li>✅ Lowest Interest Rates 13%*</li>
                    <li>✅ High Loan Amounts</li>
                    <li>✅ 360-Degree Assistance</li>
                    <li>✅ Fast Loan Processing</li>
                    <li>✅ 100% Cashback on Charges</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ Fast Loan Processing</li>
                </ul>
            </div>
        </div>
    </div>
</section>



{/*<!-- Loan Uses -->*/}
<section className="section bg-light">
    <div className="container text-center">
        <h2 className="mb-5">Uses of a Bussiness Loan</h2>
        <div className="row g-4">
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>Purchasing Inventory</h5>
                    <p>Companies use business loans to purchase new inventory and stocks, so they can continue offering its product(s) to customers. Because these loans typically do not require collateral, they are an excellent option for small businesses that do not possess many assets.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-1s">
                    <h5>Hiring Employees</h5>
                    <p>A growing business needs a solid team that drives it to success. However, the cost of hiring and training employees can be significant, especially for a small company. Business loans allow you to expand your team without feeling the pinch. Use these loans to recruit and train new employees.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Upgrading Machinery</h5>
                    <p>The most advanced machinery for your business comes at a high price. A business loan can help you purchase the latest equipment to boost output at scale. With the right loan product, you can finance these expensive yet important purchases without affecting cash flows.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

{/*<!-- Eligibility Criteria -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Business Loan in Pune Eligibility Criteria</h2>
        <div className="row text-center">
            {/* CARD 1 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/salaried-image-icon.png" 
                        alt="Eligibility" 
                        style={{ width: '200px', height: '200px' }}
                        className="mb-3"
                    />
                    <p className="text-center">Salaried/Working Professional</p>
                </div>
            </div>
            {/* CARD 2 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/age.png" 
                        alt="Age" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3" 
                    />
                    <p className="text-center">Age: 21-60 Years</p>
                </div>
            </div>
            {/* CARD 3 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/3-month-experienced.png" 
                        alt="Experience" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a job and a minimum of<br />3 months experience</p>
                </div>
            </div>
            {/* CARD 4 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/minimum-income_20000.png" 
                        alt="Income" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a minimum of Rs. 25,000<br />net income per month.</p>
                </div>
            </div>
        </div>
    </div>
</section>


{/*<!-- Apply Section -->*/}
<section id="apply" className="section bg-light text-center">
    <div className="container">
        <h2 className="mb-4">Ready to Start Your Journey?</h2>
        <p>Apply for business loan online and let MortBuzz Solutions pvt.Ltd. guide you to the best Bussiness Loans options.
</p>
        <a href="apply-now" className="apply-btn-glass btn-lg mt-3">Apply for Home Loan</a>
    </div>
</section>





{/*<!-- Documentation Required Section -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Documents Required for Business Loan</h2>
        <div className="row g-5">

            {/*<!-- Photo Identity Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        
                        <img src="/images/Bank Pages/photo-identy.png" alt="Photo-ID" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Photo Identity Proof</h5>
                    </div>
                    <ul className= "text-white">
                        <li>Voter ID</li>
                        <li>Aadhaar Card</li>
                        <li>Passport</li>
                        <li>PAN Card</li>
                        <li>Driving Licence</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Proof of Residence -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/proof-of-residence.png" alt="Address Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Proof of Residence</h5>
                    </div>
                    <ul className="text-white">
                        <li>Aadhaar Card</li>
                        <li>Driving Licence</li>
                        <li>Passport</li>
                        <li>Registered Rent Agreement</li>
                        <li>Latest Gas/Electricity Bill</li>
                        <li>Bank Statement with Current Address</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Income Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/income-proof.png" alt="Income-Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Income Proof</h5>
                    </div>
                    <ul className="text-white">
                        <li>Income Tax Returns (Last 3 Years)</li>
                        <li>Business License Details</li>
                        <li>Audited Balance Sheet & Profit/Loss (Last 3 Years)</li>
                        <li>Business Address Proof</li>
                        <li>6-Month Bank Statements (Current & Savings)</li>
                        <li>Copy of Form 16</li>
                        <li>6-Month Salary Account Statements</li>
                        <li>Last 3 Months’ Salary Slips</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Other Documents -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/other-document.png" alt="Other Documents" className="me-3" style={{width:'50px'}}/>
                        <h5 class="mb-0 text-white">Other Documents</h5>
                    </div>
                    <ul className="text-white" >
                        <li>Allotment Letter</li>
                        <li>Sale Deed</li>
                        <li>No Objection Certificate (NOC)</li>
                        <li>Allotment Letter from Society/Housing Board/Builder</li>
                        <li>Stamped Agreement of Sale</li>
                        <li>Possession Certificate</li>
                        <li>Construction Cost Estimate</li>
                        <li>Bank Payment Statement</li>
                        <li>Occupancy Certificate</li>
                        <li>Land Tax Receipt</li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>




{/*<!-- Application Process Section -->*/}
<section className="section bg-dark text-white py-5">
    <div className="container">
      <h2 className="text-center mb-5 text-white">Application Process</h2>
  
      <div className="timeline">
        {/*<!-- Step 1 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 1: Connect with Us</h4>
            <p>Explain your needs. We curate business loan in pune products most suitable for your profile.</p>
          </div>
        </div>
  
        {/*<!-- Step 2 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 2: Compare Loan Products</h4>
            <p>We help you compare several big & small business loan in pune products so you can choose the best one.</p>
          </div>
        </div>
  
        {/*<!-- Step 3 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 3: Apply Online</h4>
            <p>Pick a lender, apply online, and submit all necessary paperwork with our assistance.</p>
          </div>
        </div>
  
        
        {/*<!-- Step 4 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 4: Application Processing</h4>
            <p>The lender verifies your documentation and processes the application.</p>
          </div>
        </div>
  
        {/*<!-- Step 5 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 5: Receive Funds</h4>
            <p>Upon approval, the loan amount is credited directly to your account.</p>
          </div>
        </div>
  
      </div>
    </div>
  </section>


{/*!-- Home Loan Rates Section -->*/}
<section className="section bg-light py-5">
    <div className="container">
      <h2 className="text-center mb-5">Low Interest Rate Business Loan In Pune</h2>
  
      <div className="table-responsive">
        <table className="table table-hover table-striped shadow-lg rounded">
          <thead className="table-primary">
            <tr>
              <th>Bank Name</th>
              <th>Min. Rate of Interest (%)</th>
              <th>Loan Amount</th>
              <th>Loan Tenure</th>
              <th>Processing Fees</th>
              <th>Apply Now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> <a href="https://induseasycredit.indusind.com/STBL/small-ticket/getting-started">IndusInd Bank</a></td>
              <td>13%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>5 years - 25 years</td>
              <td>3%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.sc.com/in/business/business-expansion/business-instalment-loan/">Standard Chartered Bank</a></td>
              <td>15%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>2.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.deutschebank.co.in/en/loans/unsecured-business-loan.html">Deutsche Bank</a></td>
              <td>16%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>3%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://poonawallafincorp.com/business-loan">poonawala fincorp</a></td>
              <td>15%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>5 years - 25 years</td>
              <td>3.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.dbs.com/in/sme/financing/digibusinessloans.page">DBS Bank</a></td>
              <td>13%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>5 years - 25 years</td>
              <td>3%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.axisbank.com/retail/loans/business-loan">Axis Bank</a></td>
              <td>10.75%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>3%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td> <a href="https://www.hdfcbank.com/personal/borrow/popular-loans/business-loan">HDFC Bank</a></td>
              <td>10.75%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>2%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  </section>




  <section class="section py-5 bg-dark">
    <div class="container">
      <div class="row align-items-center g-5">
        {/*<!-- Image Section -->*/}
        <div className="col-md-6 text-center">
          <img src="/images/FrontPage/loan-dealing.jpg" alt="Processing Fee" className="img-fluid rounded shadow"/>
        </div>
  
        {/*<!-- Content Section -->*/}
        <div className="col-md-6">
          <h2 className="mb-4 text-primary" style={{fontWeight: '700'}}>Processing Fee</h2>
          <p style={{fontSize: '17px', color: '#FFEDFA'}}>
            Besides the low interest rate <strong>business loan in pune</strong>, you also need to pay a processing fee to your lender.
            This charge helps lenders cover the cost of verifying your documentation and processing your loan application.
          </p>
          <p style={{fontSize: '17px', color: '#FBFBFB'}}>
            Typically, the processing fee ranges between <strong>2% to 3.5%</strong> of your total loan amount.
            Additionally, a <strong>GST of 18%</strong> is applicable on the fee.
          </p>
          <p style={{fontSize: '17px', color: '#FBFBFB'}}>
            At <strong>MortBuzz Solutions Advisory</strong>, we help you find lenders who offer the <span style={{color: '#007bff'}}>lowest processing fees</span> on home loans — ensuring you save more from the start.
          </p>
          
          <a href="apply-now" className="apply-btn-glass mt-3">Get Best Offers</a>
        </div>
      </div>
    </div>
  </section>


  {/*<!-- mortbuzz Additionally adding Text Box Section -->*/}

<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            
            <div className="col-lg-6">
                <h2 className="mb-4 text-primary">MortBuzz Solutions Bussiness Loan Balance Transfer</h2>
                <p className="text-white">A business loan balance transfer happens when a borrower transfers the outstanding loan amount from the existing lender to a new one for the following reasons:
To get a lower interest rate
To get a lower EMI 
To get a longer tenure 
To get add-on benefits like a top-up loan If you aren’t satisfied with your current lender for some reason, you can transfer your business loan to another one offering more favourable terms. However, this decision has to be an informed one where you weigh the pros and cons of switching to a new lender well. Take factors like new rate of interest, flexibility in repayment, eligibility criteria, etc. into account.</p>
                <ul className="list-unstyled mt-3 text-white">
                    <li>✅ Lowest Interest Rates 13%*</li>
                    <li>✅ High Loan Amounts</li>
                    <li>✅ 360-Degree Assistance</li>
                    <li>✅ Fast Loan Processing</li>
                    <li>✅ 100% Cashback on Charges</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ Fast Loan Processing</li>
                </ul>
            </div>
            <div className="col-lg-6 mb-4">
                <img src="/images/FrontPage/a-soft-atmospheric-portrait-of-a-young-i_su4i5o5YT5qmZIIf5VboDw_NyivWLwnSFKpRHSgNB8djA.jpeg" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
        </div>
    </div>
</section>





{/*<!-- FAQ Section -->*/}
<div className="w-100 px-3 px-md-5 py-5 bg-black text-white w-100 bg-black">
  <h2 className="text-center mb-5 display-4 fw-bold text-primary">Frequently Asked Questions</h2>

  <div className="row justify-content-center">
    <div className="col-lg-10 col-md-12">
      <div className="accordion" id="faqAccordion">

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
              <i className="bi bi-question-circle me-3 text-primary fs-4"></i>
              What is a business loan?
            </button>
          </h2>
          <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              A business loan is a type of financing provided to entrepreneurs and enterprises to meet various business needs such as expansion, working capital, equipment purchase, or inventory stocking.


              <a href="/" className="text-primary text-decoration-none">mortbuzz.in</a>. 
              We handle everything—no bank visit needed.
            </div>
          </div>
        </div>

        
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
              <i className="bi bi-percent me-3 text-primary fs-4"></i>
              Who can apply for a business loan?
            </button>
          </h2>
          <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Business loans are available to:
              <ul>
                  <li>Proprietors</li>
                  <li>Partnership firms</li>
                <li>Private limited companies</li>
                    <li>Self-employed professionals</li>
                <li>MSMEs (Micro, Small & Medium Enterprises)</li>
                </ul>
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
               What documents are required to apply for a business loan?
            </button>
          </h2>
          <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Typical documents include:
              <ul className="mt-2">
                <li><strong>KYC of the applicant and business</strong></li>
                <li><strong>Business registration proof</strong></li>
                <li><strong>Bank statements (last 6–12 months)</strong>
</li>
<li> Income Tax Returns</li>
<li>Financial statements (P&L, balance sheet)</li>
<li>GST returns (if applicable)</li>




              </ul>
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              How much loan amount can I get?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              You can avail loan amounts ranging from ₹1 lakh to ₹1 crore (or more), depending on your business turnover, creditworthiness, and financial profile.


            </div>
          </div>
        </div>

      {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq5">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
               Do I need collateral to get a business loan?
            </button>
          </h2>
          <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              MortBuzz offers both secured (with collateral) and unsecured (without collateral) business loan options. Unsecured loans are typically offered for smaller amounts and shorter tenures.
            </div>
          </div>
        </div>


    {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq6">
              <i class="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the typical interest rate on a business loan?
            </button>
          </h2>
          <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
Interest rates usually start from 12% p.a. and vary based on:
              <ol>
                <li>Loan amount</li>
                <li>Business profile</li>
                <li>Credit score</li>
                <li>Tenure</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>

  {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq7">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
               How soon can I get the loan amount disbursed?
            </button>
          </h2>
          <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
               After successful document verification and approval, the loan can be disbursed within 3 to 7 working days.
             
            </div>
          </div>
        </div>


{/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq8">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              Can I apply for a business loan online?
            </button>
          </h2>
          <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              Yes. With MortBuzz, you can apply online in just a few minutes. Upload your documents digitally and get real-time updates.
            </div>
          </div>
        </div>


{/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq9">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
               Can I prepay my business loan?
            </button>
          </h2>
          <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Yes, most lenders allow part-prepayment or full prepayment. However, some loans may have prepayment charges, so check with your lender.
            </div>
          </div>
        </div>


{/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq10">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What happens if I miss an EMI payment?
            </button>
          </h2>
          <div id="faq10" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
                Missing EMIs can lead to:
              <ol>
                <li>Penalty charges</li>
                <li>Lower credit score</li>
                <li>Possible legal action by the lender.</li>
                
              </ol>
               Always communicate with the lender early if you expect a delay in payments.
            </div>
          </div>
        </div>


{/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              How much loan amount can I get?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Apply at <a href="https://mortbuzz.in" class="text-primary">mortbuzz.in</a>.</li>
                <li>Our team will collect your documents.</li>
                <li>We handle approval with banks.</li>
                <li>Door-to-door service with no bank visits.</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>









      </div>
    </div>
  </div>
</div>














    
    </>
  );
}

export default BusinessLoan;